import { render, staticRenderFns } from "./KategoriZIS.vue?vue&type=template&id=7a49faff&scoped=true"
import script from "./KategoriZIS.vue?vue&type=script&lang=js"
export * from "./KategoriZIS.vue?vue&type=script&lang=js"
import style0 from "./KategoriZIS.vue?vue&type=style&index=0&id=7a49faff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a49faff",
  null
  
)

export default component.exports